export const QueryKeys = {
    getAddresses: "get-addresses",
    getProfile: "get-profile",
    getServiceCloudToken: "get-service-cloud-token",
    getPostalCode: "get-postal-code",
    algoliaProducts: "algolia-products",
    getYotpoReviews: "get-yotpo-reviews",
    getPaymentMethods: "get-payment-methods",
    getExpressCheckoutContent: "express-checkout-content",
    getDeliveryMethods: "get-delivery-methods",
    amazonPaySignature: "amazon-pay-signature",
    getGlobalAddresses: "get-global-addresses",
    verifyEmail: "verify-email",
    getParcelShops: "get-parcel-shops",
    validateParcelShopPostalCode: "validate-parcel-shop-postal-code",
    getStores: "get-stores",
    getTrustpilotReviews: "get-trustpilot-reviews",
    getMultipleProducts: "get-multiple-products",
    getUnavailableProductDetails: "get-unavailable-product-details",
    getOrderDocument: "get-order-document",
    getOrderHistoryDocument: "get-order-history-document",
    getProduct: "get-product",
    getLoyaltyTransactionsPoints: "get-loyalty-transactions-points",
    getMyActiveCartData: "get-my-active-cart-data",
    getPlacedOrderCart: "get-placed-order-cart",
    getDeliveryEstimate: "get-delivery-estimate",
    getProductsAvailability: "get-products-availability",
    ensureCart: "ensure-cart",
    getEccoClubBadges: "get-ecco-club-badges",
} as const;
